import base from './base2.repository';
export default {
    ...base,
    async getSupervisionChecklistIndicators() {
        try {
            const { data } = await this.get('reporting/supervision-checklist/indicators');
            return data;
        } catch(err) {
            toastr.error(`Ocurrió un error al cargar los indicadores de las listas de chequeo [${err.message}]`);
        }
    }
}